const binding = { modules: {}, dataActions: {} };

    (binding.modules['cookie-compliance'] = {
        c: () => require('partner/modules/cookie-compliance/cookie-compliance.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cookie-compliance',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cookie-compliance'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|cookie-compliance|cookie-compliance'] = {
                c: () => require('partner/modules/cookie-compliance/cookie-compliance.view.tsx'),
                cn: '__local__-__local__-cookie-compliance'
            };
viewDictionary['@msdyn365-commerce-modules|cookie-compliance|modules|cookie-compliance|cookie-compliance'] = {
                c: () => require('@msdyn365-commerce-modules/cookie-compliance/dist/lib/modules/cookie-compliance/cookie-compliance.view.js'),
                cn: '@msdyn365-commerce-modules-cookie-compliance-cookie-compliance'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };